var _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNounlive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 27 27",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M22.572 4.428c-.567-.567-1.512-.567-2.106 0-.567.567-.567 1.512 0 2.106a9.806 9.806 0 0 1 2.89 6.966 9.806 9.806 0 0 1-2.89 6.966c-.567.567-.567 1.512 0 2.106a1.47 1.47 0 0 0 1.053.432 1.47 1.47 0 0 0 1.053-.432 12.705 12.705 0 0 0 3.753-9.045c0-3.456-1.323-6.67-3.753-9.1v.001Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M3.645 13.5a9.76 9.76 0 0 1 2.889-6.966c.567-.567.567-1.512 0-2.106-.567-.567-1.512-.567-2.106 0A12.721 12.721 0 0 0 .675 13.5c0 3.402 1.377 6.696 3.78 9.072a1.47 1.47 0 0 0 1.053.432 1.47 1.47 0 0 0 1.053-.432 1.492 1.492 0 0 0-.027-2.106c-1.836-1.809-2.89-4.347-2.89-6.966Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M18.846 8.181c-.567-.594-1.512-.594-2.106-.027-.594.567-.594 1.512-.027 2.106a4.578 4.578 0 0 1 1.35 3.24 4.579 4.579 0 0 1-1.35 3.24 1.492 1.492 0 0 0 .027 2.106 1.47 1.47 0 0 0 1.053.432 1.47 1.47 0 0 0 1.053-.432A7.495 7.495 0 0 0 21.06 13.5a7.478 7.478 0 0 0-2.214-5.32v.001Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M10.26 8.154c-.568-.567-1.513-.567-2.107 0A7.54 7.54 0 0 0 5.94 13.5c0 2.025.783 3.915 2.214 5.346a1.47 1.47 0 0 0 1.053.432 1.47 1.47 0 0 0 1.053-.432c.567-.567.567-1.512 0-2.106a4.578 4.578 0 0 1-1.35-3.24c0-1.215.486-2.376 1.35-3.24.594-.567.594-1.512 0-2.106Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M15.767 13.5a2.268 2.268 0 1 1-4.536 0 2.268 2.268 0 0 1 4.536 0Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 23.183,
    x2: 23.183,
    y1: 4.003,
    y2: 23.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F2CF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CD4CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 3.829,
    x2: 3.829,
    y1: 4.003,
    y2: 23.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F2CF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CD4CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 18.675,
    x2: 18.675,
    y1: 7.732,
    y2: 19.278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F2CF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CD4CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 8.322,
    x2: 8.322,
    y1: 7.729,
    y2: 19.278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F2CF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CD4CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 13.499,
    x2: 13.499,
    y1: 11.232,
    y2: 15.768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F2CF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CD4CFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounlive);
export default __webpack_public_path__ + "static/media/nounlive.c3c105e7184613fa3134598a6934bd9e.svg";
export { ForwardRef as ReactComponent };